const _state = {
  affectedPermissionData: null,
}
//{permission:int, operation:I/U} Insert o Update

export const initialState = () => _state

export const state = initialState()
